import React, { JSX, FC, useEffect } from "react";
import { useParams, useNavigate, Params } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "antd/es/form/Form";
import { Badge, Tabs } from "antd";

// redux
import { AppDispatch } from "redux/store/store";
import { fetchModeratorCommentsCount } from "redux/thunks/moderatorComments.thunk";
import { InitialModeratorCommentsStateType } from "redux/slices/moderatorCommentsSlice";
import { AppStateType } from "redux/reducers/mainReducer";

// components
import TabWrapper from "components/Catalog/TabWrapper/TabWrapper";

import css from "./style.module.scss";
import "./antdStyle.scss";

interface ITabsWithCountersProps { }

export enum Tab {
	uploaded = "Загруженные товары",
	uploading = "Загруженные файлы",
	comparison = "Сопоставление категорий",
	comments = "Комментарии от модератора",
}

export type TabKey = keyof typeof Tab;

const TAB_KEYS: TabKey[] = Object.keys(Tab) as TabKey[];

interface RouteParams extends Params {
	tab?: string;
}

const TabsWithCounters: FC<ITabsWithCountersProps> = (): JSX.Element => {
	const { tab } = useParams<RouteParams>();
	const navigate = useNavigate();

	const dispatch: AppDispatch = useDispatch();
	const [form] = useForm<any>();

	const moderatorComments: InitialModeratorCommentsStateType = useSelector(
		(state: AppStateType) => state.moderatorCommentsSlice
	);

	const tabKeyFromUrl: TabKey = TAB_KEYS.includes(tab as TabKey) ? (tab as TabKey) : "uploaded";
	const activeTabKey: TabKey = tabKeyFromUrl || "uploaded";
	const activeTabLabel: string = Tab[activeTabKey];

	useEffect(() => {
		if (!tabKeyFromUrl) {
			navigate(`/import/${activeTabKey}`, { replace: true });
		}
	}, [tab, tabKeyFromUrl, navigate, activeTabKey]);

	// TODO пока не делаем комментарии модератора
	// useEffect(() => {
	//   dispatch(fetchModeratorCommentsCount());
	// }, [activeTabKey]);

	const renderLabel = (title: string, count: number = 0): JSX.Element => {
		const countStyle: React.CSSProperties = {
			marginLeft: 4,
			color: activeTabLabel === title ? "#0a84ff" : "#374151",
			backgroundColor: activeTabLabel === title ? "#0A84FF1A" : "#67768C1A"
		};

		return (
			<span>
				{title}
				<Badge
					style={countStyle}
					count={count || null}
					overflowCount={999}
				/>
			</span>
		);
	};

	const handleNavigateTab = (key: TabKey): void => navigate(`/import/${key}`);

	const onChange = (key: TabKey): void => {
		form.resetFields();
		handleNavigateTab(key);
	};

	const renderTabPane = (tabKey: TabKey, count: number = 0): JSX.Element => (
		<Tabs.TabPane
			key={tabKey}
			tab={renderLabel(Tab[tabKey], count)}
		>
			{activeTabKey === tabKey && (
				<TabWrapper currentTab={Tab[tabKey]} setActiveTab={handleNavigateTab} form={form} />
			)}
		</Tabs.TabPane>
	);

	return (
		<div className={css.wrapper}>
			<Tabs
				className="pr-6 pl-10 w-full tabsWithCounters"
				activeKey={activeTabKey}
				onChange={onChange}
			>
				{renderTabPane("uploaded")}
				{renderTabPane("uploading")}
				{renderTabPane("comparison")}
				{/* {renderTabPane("comments", moderatorComments.count)} TODO пока скрываем */}
			</Tabs>
		</div>
	);
};

export default TabsWithCounters;
